import Spin from 'components/Spin'

const ButtonAction = ({
  name,
  size,
  color,
  colorOpacity,
  type,
  text,
  textColor,
  className,
  loading,
  handleChange,
  disabled,
  lightLoading = false,
  ...attributes
}) => (
  <button
    name={name}
    type={type || 'button'}
    className={`flex items-center justify-center rounded-full border border-transparent text-base font-alliance-medium lg:min-w-[250px] ${
      disabled
        ? 'bg-sec-grey-1 opacity-50 cursor-not-allowed'
        : color
        ? `bg-${color} hover:bg-${color}-hover`
        : 'bg-accent hover:bg-[#c9e300]'
    }
    ${colorOpacity ? `bg-opacity-${colorOpacity}` : null}
    ${textColor ? `text-${textColor}` : 'text-blue'}
    ${
      size === 'small'
        ? ' px-4 py-1 md:py-2 md:px-5 text-[14px] lg:text-[18px]'
        : ' px-16 py-4 md:py-6 md:px-10 text-[18px] lg:text-[24px]'
    }
    ${className}`}
    onClick={handleChange}
    disabled={disabled}
    {...attributes}
  >
    {text}
    {loading && (
      <Spin
        size="6"
        className="ml-5"
        color={`${lightLoading ? 'text-white' : 'text-blue'}`}
      />
    )}
  </button>
)

export default ButtonAction
